import { BehindEveryPetition } from './components/BehindEveryPetition';
import { ClosingCta } from './components/ClosingCta';
import { Hero } from './components/Hero';
import { LocalWins } from './components/LocalWins';
import { PetitionStarters } from './components/PetitionStarters';
import { PoweredByPeople } from './components/PoweredByPeople';
import { StatsBand } from './components/StatsBand';
import { WhoUses } from './components/WhoUses';

/** Each section owns its bottom padding, so a hidden Petition starters section leaves no gap. */
export const PageBody = () => {
	return (
		<div>
			<Hero />
			<PoweredByPeople />
			<StatsBand />
			<PetitionStarters />
			<LocalWins />
			<WhoUses />
			<BehindEveryPetition />
			<ClosingCta />
		</div>
	);
};
